module.exports = __webpack_public_path__ + "static/img/banner.ff817654.png";